import { Spacing } from '@approvalmax/ui/src/components';
import { useSetupProfileWizardQualificationQuestionsAnswers } from 'app/(workspace)/profileSetup/resources/hooks';
import {
    AcceptInvitationsStep,
    MobileSuccessInfo,
    PendingPracticeInvitationStep,
} from 'pages/auth/pages/FirstTimeSetupPage/components';
import { memo } from 'react';

import { PreAhaMoment } from '../../../../resources/components';
import { ProfileStepContainer } from '../ProfileStepContainer/ProfileStepContainer';
import { useSetupProfileWizard } from './SetupProfileWizard.hooks';
import { messages } from './SetupProfileWizard.messages';
import { Body, NextButton, Root, Title } from './SetupProfileWizard.styles';
import { FirstStartWizardStep, SetupProfileWizardProps } from './SetupProfileWizard.types';

export const SetupProfileWizard = memo<SetupProfileWizardProps>((props) => {
    const { onShowPreAhaMoment } = props;

    const {
        invitations,
        profileData,
        handleGoToNextStep,
        profile,
        loading,
        currentStep,
        practiceInvitations,
        isMobileScreen,
        selectedPracticeInvitation,
        acceptedInvitationIds,
        onAcceptedInvitationsChange,
        onAcceptedPracticeInvitationsChange,
        stepInfo,
    } = useSetupProfileWizard(onShowPreAhaMoment);

    const { useCases, answerAboutGL, handleSetQualificationQuestionsAnswers } =
        useSetupProfileWizardQualificationQuestionsAnswers();

    if (currentStep === FirstStartWizardStep.Profile) {
        return (
            <ProfileStepContainer
                invitations={invitations}
                profileData={profileData}
                onGoToNextStep={handleGoToNextStep}
                onSetQualificationQuestionsAnswers={handleSetQualificationQuestionsAnswers}
                email={profile?.email}
            />
        );
    }

    if (currentStep === FirstStartWizardStep.PreAhaMoment) {
        return <PreAhaMoment answerAboutGL={answerAboutGL} useCases={useCases} onNext={handleGoToNextStep} />;
    }

    // TODO: This part will be redesigned later when new templates are ready
    if (currentStep === FirstStartWizardStep.MobileSuccessInfo) {
        return (
            <Root>
                <Body>
                    <MobileSuccessInfo />
                </Body>
            </Root>
        );
    }

    // TODO: This part will be redesigned later when new templates are ready
    return (
        <Root>
            {isMobileScreen ? <Spacing height={40} /> : <Title>{stepInfo.stepTitle}</Title>}

            <Body $withPadding>
                {currentStep === FirstStartWizardStep.AcceptInvitations && (
                    <AcceptInvitationsStep
                        invitations={invitations}
                        acceptedInvitationIds={acceptedInvitationIds}
                        onAcceptedChange={onAcceptedInvitationsChange}
                        onNext={handleGoToNextStep}
                    />
                )}

                {currentStep === FirstStartWizardStep.AcceptPracticeInvitations && (
                    <PendingPracticeInvitationStep
                        value={selectedPracticeInvitation}
                        invitations={practiceInvitations}
                        onSelectOption={onAcceptedPracticeInvitationsChange}
                    />
                )}

                <NextButton
                    execute={handleGoToNextStep}
                    disabled={loading}
                    preset={isMobileScreen ? 'large' : 'normal'}
                >
                    {messages.nextButton}
                </NextButton>
            </Body>
        </Root>
    );
});

SetupProfileWizard.displayName = 'SetupProfileWizard';
